import { createSelector } from "@reduxjs/toolkit";

export const socialActivityEnabledSelector = createSelector<[(state: LSStore.State) => LSCommon.BrandedJsModel | null], boolean>(state => state.branding.value, branding => branding?.socialActivityEnabled ?? false);
